import useSortOrder from 'Utilities/hooks/vehicleList/useSortOrder/useSortOrder';
import { FOR_SALE_CATEGORY } from 'Utilities/vehicleState';

import { OPTIMIZELY_EVENTS } from '../optimizely.consts';

import { useTrackEventWhenReady } from './useTrackEventWhenReady';

type UseTriggerVehicleCardClickedEvent = (stateSlug: string) => void;

export const useTriggerVehicleCardClickedEvent = (): UseTriggerVehicleCardClickedEvent => {
	const track = useTrackEventWhenReady(OPTIMIZELY_EVENTS.VEHICLE_CARD_CLICKED);
	const { sort } = useSortOrder();

	return (stateSlug) => {
		const isSaleActiveVehicle = stateSlug === FOR_SALE_CATEGORY.SALE_ACTIVE;
		const isRecommendedSortOrderActive = sort === 'recommended';

		track({
			attributes: {
				isLiveSale: isSaleActiveVehicle,
				isRecommendedSortOrderActive,
			},
			condition: isSaleActiveVehicle,
		});
	};
};
